export default "__VITE_ASSET__Builo5Qk__"